import {gsap, ScrollTrigger} from "../LibrariesImport";

export default class AppearOnScroll {
	static init() {
		if (ScrollTrigger.isTouch === 1) {
			return;
		}
		const items = document.querySelectorAll("[data-aos]");

		items.forEach((item) => {
			const delay = item.dataset.aosDelay ?? 0; // Utilisez l'attribut HTML `data-aos-delay`

			// Créez une timeline GSAP avec un délai personnalisé
			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: item,
					start: "top 90%",
				},
			});

			// Ajoutez une animation vide avec un délai pour appliquer la classe "appeared"
			timeline.to(item, { duration: 0, delay: parseFloat(delay), onComplete: () => item.classList.add("appeared") });
		});
	}
}